export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path.endsWith('abortNavigation')) {
    // Abort navigation to prevent 404 generated by nuxt which loads an entire page
    return abortNavigation();
  }
});
